import api from "./apiLogisticsTool";

export default {
  GetWidgets() {
    return api.get("Widgets/GetWidgets/");
  },

  GetWidget(id) {
    return api.get("Widgets/GetWidget/" + id);
  }
};
